export default "__VITE_ASSET__Ck1JRXZj__"